<template>
  <div class="page-productDetails">
    <Header :showBack="true" />
    <div class="page-content">
      <div class="top-base">
        <div class="info-content">
          <h2 class="top-title">
            <span v-html="detailsData.shop_product_name"></span>
            <img v-if="detailsData.activity_tag == 1" class="icon-join" src="../../assets/images/icon-join.png" alt="">
            <!-- <img v-if="detailsData.claimant" class="icon-join" src="../../assets/images/icon-rl-success.png" alt=""> -->
          </h2>
          <p class="cas" v-if="detailsData.cas_number != ''">CAS: <span v-html="detailsData.cas_number"></span></p>
          <p class="info" v-if="detailsData.trademark != '' || detailsData.grade != ''">
            <span class="label" v-if="detailsData.trademark != ''">Trademark</span>
            <span class="text" v-if="detailsData.trademark != ''">{{ detailsData.trademark }}</span>
          </p>
        </div>
        <div class="get-invoice" @click="setDialogInvoiceVisible">
          <p><span class="invoice-text">Request sample</span></p>
        </div>
        <div class="score">
          <div class="score-item">
            <p class="score-title">Stable quality</p>
            <div class="start">
              <img
                :src="`${Number(detailsData.evaluate_quality_avg / 2) > index ? require('../../assets/images/start_active.png') : require('../../assets/images/start.png')}`"
                align="" class="start-img" v-for="(item, index) in 5" />
            </div>
            <span class="num">{{ detailsData.evaluate_quality_avg }}</span>
          </div>
          <div class="score-item">
            <p class="score-title">Technological innovation</p>
            <div class="start">
              <img
                :src="`${Number(detailsData.evaluate_technology_avg / 2) > index ? require('../../assets/images/start_active.png') : require('../../assets/images/start.png')}`"
                align="" class="start-img" v-for="(item, index) in 5" />
            </div>
            <span class="num">{{ detailsData.evaluate_technology_avg }}</span>
          </div>
        </div>
      </div>
      <div class="product-desc" v-html="detailsData.product_description"></div>
      <div class="tab-view">
        <div class="tab-box">
          <div class="tab-panel" v-if="companyData">
            <div class="product-details">
              <router-link :to="`/companyDetails?companyId=${this.companyId}`">
                <div class="top">
                  <img :src="companyData.pc_logo || config.DEFAULT_SHOP_LOGO" alt="" class="cover shop_logo" />
                  <div class="company-info">
                    <p class="name ">
                      <span>{{ companyData.shop_name_en }}</span>
                      <img src="https://style-stg.ibuychem.com/wiseshop/pc/icon/shopinfo/images/en_qiicon_01.png"
                        height="16" alt=""><img :src="companyData.tags_img" width="20" alt="">
                    </p>
                    <p class="text">
                      <span class="product-label">There are plenty of products</span>
                      <span class="product-num">{{ companyData.quality }}</span>
                    </p>
                    <p class="text">
                      <span class="product-label">Supply chain support</span>
                      <span class="product-num">{{ companyData.services }}</span>
                    </p>
                    <p class="text">
                      <span class="product-label">Technical support</span>
                      <span class="product-num">{{ companyData.innovation }}</span>
                    </p>
                    <p class="text">
                      <span class="product-label">Stable supply</span>
                      <span class="product-num">{{ companyData.service }}</span>
                    </p>
                    <p class="text">
                      <span class="product-label">Respond quickly</span>
                      <span class="product-num">{{ companyData.performance }}</span>
                    </p>
                  </div>
                </div>
              </router-link>
              <!-- <div class="video-box" v-if="supplierListData ? supplierListData.length : false">
                <span class="video-label">Supplier</span>
                <div class="video-group">
                  <a :href="item.url ? item.url : 'javascript:;'" v-for="(item, index) in supplierListData"
                    :key="index">
                    <img :src="item.logo" alt="" class="video-img" />
                  </a>
                </div>
              </div>
              <div class="video-box" v-if="userListData ? userListData.length : false">
                <span class="video-label">Customer</span>
                <div class="video-group">
                  <a :href="item.url ? item.url : 'javascript:;'" v-for="(item, index) in userListData" :key="index">
                    <img :src="item.logo" alt="" class="video-img" />
                  </a>
                </div>
              </div> -->
            </div>
          </div>
          <div class="tab-panel">
            <h3 class="panel-title">Product Information</h3>
            <div class="product-info">
              <div class="info" v-if="detailsData.chemical_name">
                <p class="info-title">Chemical name</p>
                <p class="info-name">{{ detailsData.chemical_name }}</p>
              </div>
              <div class="info" v-if="detailsData.colour || detailsData.physical_form">
                <p class="info-title">Appearance</p>
                <p class="info-name" v-html="detailsData.colour + detailsData.physical_form"></p>
              </div>
              <div class="info" v-if="detailsData.molecular_formula">
                <p class="info-title">Chemical formula</p>
                <p class="info-name" v-html="detailsData.molecular_formula"></p>
              </div>
              <div class="info" v-if="detailsData.molecular_weight">
                <p class="info-title">Molecular weight</p>
                <p class="info-name" v-html="detailsData.molecular_weight"></p>
              </div>
              <div class="info" v-if="detailsData.shelf_life">
                <p class="info-title">Quality guarantee period</p>
                <p class="info-name"> {{ detailsData.shelf_life }} </p>
              </div>
            </div>
            <div class="product-type">
              <div class="type">
                <span class="label">Product classification</span>
                <ul class="type-list">
                  <li>{{ detailsData.position_class }}</li>
                </ul>
              </div>
              <div class="type" v-if="detailsData.application_class">
                <span class="label">Application classification</span>
                <ul class="type-list">
                  <li>{{ detailsData.application_class }}</li>
                </ul>
              </div>
            </div>
            <div class="characteristic" v-show="detailsData && detailsData.product_characteristics.length > 0">
              <p class="characteristic-title">Performance characteristics</p>
              <div class="text" v-for="item in detailsData.product_characteristics">
                <div v-html="item.product_characteristics"></div>
              </div>
            </div>
            <div class="characteristic" v-show="detailsData && detailsData.storage_condition">
              <p class="characteristic-title">Storage conditions</p>
              <div class="text" v-html="detailsData.storage_condition"></div>
            </div>
          </div>
          <div class="tab-panel" v-if="detailsData.video_img || detailsData.video_url">
            <h3 class="panel-title">Product Video</h3>
            <div class="product-video">
              <video controls="controls" muted="muted" :src="detailsData.video_url" :poster="detailsData.video_img"
                crossorigin="anonymous" width="100%" v-if="detailsData.video_url"></video>
              <img :src="detailsData.video_img" v-else-if="detailsData.video_img" />
            </div>
          </div>
          <div class="tab-panel"
            v-if="detailsData ? detailsData.product_physical ? detailsData.product_physical.length ? true : false : false : false">
            <h3 class="panel-title">Performance Parameter</h3>
            <div class="formula-table">
              <div class="thead">
                <div class="tr">
                  <span class="th">Performance parameters</span>
                  <span class="th">Numeric/unit</span>
                  <span class="th">Test conditions/standards</span>
                </div>
              </div>
              <div class="tbody">
                <div class="tr" v-for="item in (detailsData.product_physical ? detailsData.product_physical : [])">
                  <span class="td">{{ item.nature }}</span>
                  <span class="td" v-html="item.number"></span>
                  <span class="td" v-html="item.condition"></span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="tab-panel"
            v-if="detailsData ? (detailsData.case || detailsData.msds || detailsData.upload_instructions || detailsData.tds) ? true : false : false">
            <h3 class="panel-title">Related Documents</h3>
            <div class="documents">
              <div class="item" v-show="detailsData.msds">
                <img src="https://style.ibuychem.com/wiseshop/pc/images/pdf.png" alt="" class="documents-img" />
                <div class="documents-info">
                  <a :href="config.PHPHOST + detailsData.msds">
                    <p class="name line-clamp-1">
                      {{ detailsData.munufacturer_abbreviation }}<span v-html="detailsData.product_name"></span><span
                        v-html="detailsData.grade"></span>Chemical Safety Data Sheet(msds).pdf
                    </p>
                  </a>
                </div>
              </div>
              <div class="item" v-show="detailsData.tds">
                <img src="https://style.ibuychem.com/wiseshop/pc/images/pdf.png" alt="" class="documents-img" />
                <div class="documents-info">
                  <a :href="config.PHPHOST + detailsData.tds">
                    <p class="name line-clamp-1">
                      {{ detailsData.munufacturer_abbreviation }}<span v-html="detailsData.product_name"></span><span
                        v-html="detailsData.grade"></span>Chemical Technical Data Sheet(tds).pdf
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div> -->
          <div class="tab-panel">
            <h3 class="panel-title">Manufacturer Information</h3>
            <ul class="base-list">
              <li v-show="detailsData ? detailsData.place_of_origin ? true : false : false">
                <span class="label">Origin</span>
                <span class="text">{{ detailsData.place_of_origin }}</span>
              </li>
              <li v-show="detailsData ? detailsData.munufacturer_abbreviation ? true : false : false">
                <span class="label">Manufacturer's abbreviation</span>
                <span class="text">{{ detailsData.munufacturer_abbreviation }}</span>
              </li>
              <li v-show="detailsData ? detailsData.brand ? true : false : false">
                <span class="label">Product branding</span>
                <span class="text" v-html="detailsData.brand"></span>
              </li>
              <li v-show="detailsData.grade">
                <span class="label">Product model</span>
                <span class="text" v-html="detailsData.grade"></span>
              </li>
            </ul>
          </div>
          <div class="tab-panel recommed-list">
            <h3 class="panel-title">Relevant Recommendations</h3>
            <div class="recommed-warrper">
              <div class="recommend-item" v-for="(item, index) in recommendPorListOdd"
                @click="toDetails(item.details_id)">
                <div class="recommend-title-warrper">
                  <h3 class="recommend-title line-clamp-2">{{ item.product_name }}</h3>
                </div>
                <p class="recommend-text line-clamp-1">CAS: {{ item.cas_number }}</p>
                <p class="recommend-text line-clamp-1">Brands: {{ item.grade }}</p>
                <p class="recommend-text line-clamp-1">Trademark: {{ item.trademark }}</p>
              </div>
            </div>
            <div class="recommed-warrper">
              <div class="recommend-item" v-for="(item, index) in recommendPorListEven"
                @click="toDetails(item.details_id)">
                <div class="recommend-title-warrper">
                  <h3 class="recommend-title line-clamp-2">{{ item.product_name }}</h3>
                </div>
                <p class="recommend-text line-clamp-1">CAS: {{ item.cas_number }}</p>
                <p class="recommend-text line-clamp-1">Brands: {{ item.grade }}</p>
                <p class="recommend-text line-clamp-1">Trademark: {{ item.trademark }}</p>
              </div>
            </div>
          </div>
          <a :href="`/#/companyDetails?companyId=${this.companyId}`" class="more-btn">
            See more
            <img src="../../assets/images/more-boxshadow.png" alt="">
          </a>
        </div>
      </div>
    </div>
    <Footer />
    <demand-btn :instance="$demoInstance"
      :save-options="{ data_source: 2, u_source: 1, crm_source: source === 'cms' ? 1 : 0 }" />
  </div>
</template>
<script>
  import header from "../common/header";
  import footer from "../common/footer";
  import config from "../../common/config";
  import axios from "axios";
  import qs from "qs";
  export default {
    name: "",
    data() {
      return {
        config,
        id: "",
        source: '',
        munufacturer_id: "",
        companyId: "", // 公司id
        productName: "", // 商品名称
        detailsData: "", // 详情
        companyData: "", // 公司
        recommendPorList: [],
        userListData: [], // 用户
        supplierListData: [], //供应商
        page: 1, // 分页
        isLoading: false, // 加载状态
        integralTimer: null, // 积分任务计时器
      };
    },
    metaInfo: {
      title: 'AI Selection for Materials - from Ibuychem.com,Leading Manufacturers & Suppliers of Chemical Materials and Products in China',
      meta: [
        { name: "keywords", content: "chemical raw material, chemical properties,properties,chemical brand,coatings, inks, plastic,adhesive,PE,PP,PVC,resin,pigments, additives,TDS,MSDS,SDS" },
        { name: "description", content: "Provide performance tables for over 200000 types of chemical raw materials, and continuously improve and add new ones. You can directly search and browse online or print and read the product performance table you have found. The current  performance table parameters include injection molding parameters, plastic melt index, hardness, flow index, plastic raw material usage, etc; The chemical performance table parameters include: content, dosage PH、 Formulas, alternative products, etc." }
      ]
    },
    filters: {
      // 立即使用
      toDate(number) {
        var n = number;
        var date = new Date(n);
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1) + "-";
        var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return Y + M + D;
      }
    },
    watch: {
      $route: function (from, to) {
        if (from.name === to.name) {
          Object.assign(this.$data, this.$options.data());
          this.init();
        }
      }
    },
    created() {
      this.init();
    },
    mounted() {
      this.integralTimer = integral.delay({
        env: config.ENV === "production" ? "pro" : "dev",
        code: "00_03_00_001",
        entityType: "ylk_goods",
        system: 3,
        entityId: this.id,
        callback: function () { }
      },
        15000
      );
    },
    beforeDestroy() {
      if (this.integralTimer) {
        clearTimeout(this.integralTimer);
      }
    },
    computed: {
      recommendPorListOdd: function () {
        var result = [];
        this.recommendPorList.map((v, k) => {
          if (k % 2 === 0) {
            result.push(v);
          }
        });
        return result;
      },
      recommendPorListEven: function () {
        var result = [];
        this.recommendPorList.map((v, k) => {
          if (k % 2 !== 0) {
            result.push(v);
          }
        });
        return result;
      }
    },
    methods: {
      init() {
        this.id = this.$route.query.id;
        this.source = this.$route.query.source
        this.munufacturer_id = this.$route.query.munufacturer_id;
        window.scrollTo(0, 0);
        _hmt.push(["_trackPageview", `/${window.location.hash}`]);
        this.getData();
      },
      // 索取样品可视化
      setDialogInvoiceVisible() {
        this.$demoInstance.show({
          goods_name: this.detailsData.product_name,
          goods_id: this.id,
          company_id: this.companyId,
          data_source: 2,
          crm_source: this.source === 'cms' ? 1 : 0
        }, {
          productName: this.detailsData.product_name,
          model: this.detailsData.grade,
          manufacturer: this.detailsData.munufacturer_name
        });
      },
      getData() {
        axios
          .get(
            config.PHPHOST +
            "api/web/index.php?r=second/product/detail&detailsId=" +
            this.id +
            "&portType=2"
          )
          .then(res => {
            if (res.data.error_code === 0) {
              this.detailsData = res.data.data;
              this.detailsData.product_characteristics =
                res.data.data.product_characteristics;
              this.companyId = res.data.data.munufacturer_id; // 公司id || 生产商id
              this.productName = res.data.data.product_name;
              if (res.data.data.munufacturer_id) {
                this.getComponentInfo(res.data.data.munufacturer_id);
                this.getUserList(res.data.data.munufacturer_id);
                this.getRecommendList();
              }
              // 产品名称 productName  生产商简称 munAbb 商标trademark  牌号 grade
              var _title = "AI Selection for Materials - from Ibuychem.com,Leading Manufacturers & Suppliers of Chemical Materials and Products in China";
              _title = _title.replace(/<sup>|<\/sup>/gim, "");
              document.title = _title;
              WeChatShare({
                callback: () => {
                  var desc = "",
                    imgUrl = config.PHPHOST + "frontend/web/images/logo-new.jpg",
                    link =
                      window.location.origin +
                      "/#/prodetail?id=" +
                      this.id +
                      `&munufacturer_id=${this.munufacturer_id}`;
                  if (this.detailsData.product_description) {
                    desc = this.detailsData.product_description;
                    desc = desc.replace(/<sup>|<\/sup>/gim, "");
                  } else {
                    desc =
                      "Provide performance tables for over 200000 types of chemical raw materials, and continuously improve and add new ones. You can directly search and browse online or print and read the product performance table you have found. The current  performance table parameters include injection molding parameters, plastic melt index, hardness, flow index, plastic raw material usage, etc; The chemical performance table parameters include: content, dosage PH、 Formulas, alternative products, etc.";
                  }
                  wx.onMenuShareAppMessage({
                    title: _title,
                    desc: desc,
                    link: link,
                    imgUrl: imgUrl
                  });
                  wx.onMenuShareTimeline({
                    title: _title + " - " + desc,
                    link: link,
                    imgUrl: imgUrl
                  });
                },
                data: "url=" + encodeURIComponent(window.location.href),
                url: config.MAPI
              });
            }
          });
      },
      // 公司
      getComponentInfo(id) {
        axios
          .post(
            config.MallApi + "api/wshop/shop/shop-visiting-card",
            qs.stringify({
              companyId: id
            })
          )
          .then(res => {
            if (res.data.error_code === 0) {
              this.companyData = res.data.data;
            }
          });
      },
      // 客户
      getUserList(id) {
        axios
          .get(
            config.MallApi + "api/wshop/shop/supplier-customers?companyId=" + id
          )
          .then(res => {
            if (res.data.error_code === 0) {
              this.userListData = res.data.data.preferred_customers;
              this.supplierListData = res.data.data.material_supplier;
            }
          });
      },
      // 推荐
      getRecommendList() {
        if (!this.isLoading) {
          this.isLoading = true;
        }
        axios
          .post(
            config.PHPHOST + "api/web/index.php?r=second/product/munufacturer",
            qs.stringify({
              companyId: this.companyId,
              goodsId: this.detailsData.details_id,
              page: this.page,
              pageSize: 8
            })
          )
          .then(res => {
            if (res.data.error_code === 0) {
              var data = res.data.data.model;
              var totalNum = Number(res.data.data.total_num);
              var isEnd = this.page >= Math.ceil(totalNum / 10) ? true : false;
              if (!isEnd) {
                this.isLoading = false;
              }
              this.recommendPorList = this.recommendPorList.concat(data);
            }
          });
      },
      // 推荐加载
      downloadRecommend() {
        this.page = this.page + 1;
        this.getRecommendList();
      },
      toDetails(id) {
        const url = window.location.href.replace(/id=\d*[^&]*/, "id=" + id);
        window.location.href = url;
      }
    },
    components: {
      Header: header,
      Footer: footer,
    }
  };

</script>
<style scoped lang="less">
  .page-productDetails {
    background: #0a1a5d;
    font-size: 1.2rem;
    color: #333;
    font-family: "微软雅黑";
    display: flex;
    flex-direction: column;
    height: 100%;

    button,
    textarea,
    input {
      outline: none;
      box-sizing: border-box;
    }

    .line-clamp-3 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .line-clamp-2 {
      display: block;
      line-height: 24px !important;
      height: 48px !important;
      overflow: hidden;
    }

    .page-content {
      position: relative;
      background: #f8f8f8;
      border-top-left-radius: 2.92rem;
      border-top-right-radius: 2.92rem;
      padding: 3.25rem 1.25rem 0;
      flex: 1;

      .get-invoice {
        width: 100%;
        height: 2.5rem;
        text-align: center;
        margin-top: 1.5rem;

        .invoice-text {
          width: 94%;
          height: 2.75rem;
          line-height: 2.75rem;
          border-radius: 0.5rem;
          display: inline-block;
          font-size: 1.25rem;
          color: #fff;
          background: #0c317a;
        }
      }
    }

    .text-center {
      text-align: center;
    }

    .block {
      display: block !important;
    }

    .top-base {
      .info-content {
        padding: 0 5rem 0 1rem;
      }

      .top-title {
        font-size: 2rem;
        font-weight: 900;
        line-height: 2.4rem;
      }

      .subtitle {
        padding-top: 1rem;
        font-size: 1.2rem;
        line-height: 1.5rem;
        margin-bottom: 1.5rem;

        .company {
          font-size: 1.2rem;
          font-weight: 900;
          margin: 0 0.42rem 0 0.84rem;
        }

        .company-icon {
          width: 1.5rem;
          height: 1.5rem;
          display: inline-block;
          margin-right: 0.82rem;
          background: url("../../assets/images/company.png") no-repeat scroll center/cover;
          vertical-align: text-bottom;
        }
      }

      .cas {
        padding: 0 0 1.5rem;
        font-size: 1.2rem;
      }

      .info {
        margin-bottom: 1.5rem;

        .label {
          margin-right: 0.33rem;
          font-size: 1.2rem;
          color: #999;
        }

        .text {
          margin-right: 1.625rem;
          font-size: 1.2rem;
        }
      }

      .score {
        padding: 2.08rem 0 0 1rem;
        display: flex;

        .score-item {
          position: relative;
          flex: 1 1;
          padding: 0 2% 0 6%;
          font-size: 1.2rem;

          &:first-child {
            padding-left: 0;
          }

          &:after {
            content: "";
            position: absolute;
            bottom: 0;
            right: 0;
            width: 0.084rem;
            height: 1.875rem;
            display: inline-block;
            background: #e6e6e6;
          }

          .score-title {
            color: #999;
          }

          .start {
            float: left;
            padding-top: 0.5rem;
            vertical-align: text-bottom;

            .start-img {
              width: 0.84rem;
              height: 0.84rem;
              margin-right: 0.23rem;
            }
          }

          .num {
            float: left;
            margin-top: 0.5rem;
            margin-left: 0.21rem;
            font-weight: 900;
            color: #666;
          }
        }
      }

      .go-grade {
        width: 27.5%;
        font-size: 1.2rem;
        line-height: 2.5rem;
        text-align: right;

        .grade-icon {
          width: 1.29rem;
          height: 0.71rem;
          display: inline-block;
          margin-left: 0.14rem;
          background: url("../../assets/images/right_blue.png") no-repeat scroll center/cover;
        }
      }
    }

    .tab-btn {
      height: 3.8rem;
      display: flex;
      padding: 0 0.6rem;
      margin: 1.66rem 0;
      border-radius: 2.5rem;
      background: url("../../assets/images/tab_bg.png") no-repeat scroll top/cover;
      background-size: 100% 100%;
      align-items: center;

      .btn-item {
        flex: 1 1;
        height: 3.1rem;
        margin-right: 0.58rem;
        border-radius: 1.8rem;
        text-align: center;
        line-height: 3.1rem;
        color: #525252;

        &.active {
          background: #597eff;
          color: #fff;
          border: 0.05rem solid #fff;
          font-weight: 900;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .tab-view {
      overflow: hidden;

      .relative {
        position: relative;
      }

      .suply-btn {
        position: absolute;
        top: 1.66rem;
        right: 0;
        width: 4.16rem;
        height: 4.16rem;
        display: inline-block;
        background: url("../../assets/images/suply_btn.png") no-repeat scroll top/cover;
      }
    }

    .tab-panel {
      background: #fff;
      padding: 1rem;
      border-radius: 1rem;
      margin-bottom: 1.83rem;
      box-shadow: 2px 2px 6px #ededed;

      .product-details {
        .top {
          display: flex;
          padding: 1.75rem 0 1.95rem 1.375rem;
          background: #f2f4fb;
          border-radius: 0.5rem;
          align-items: center;

          .cover {
            width: 7.29rem;
            height: 7.29rem;
            margin-right: 1.25rem;
          }

          .company-info {
            flex: 1 1;
            width: 20%;

            .name {
              // padding: 0.625rem 0 1.08rem;
              font-size: 1.4rem;
              margin-bottom: 1rem;
              font-weight: bold;

              >span {
                vertical-align: middle;
              }

              >img {
                vertical-align: middle;
                margin-right: 4px;
              }
            }

            .text {
              float: left;
              min-width: 50%;
              overflow: hidden;
              margin-bottom: 1rem;
            }

            .product-label {
              float: left;
              margin-right: 0.35rem;
              color: #999;
            }

            .product-num {
              float: left;
              color: #555;
              font-weight: 600;
            }
          }
        }

        .video-box {
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 1.75rem;

          &:last-child {
            margin-bottom: 0.7rem;
          }

          .video-label {
            width: 5rem;
            height: 1.91rem;
            display: inline-block;
            font-size: 1rem;
            line-height: 1.91rem;
            text-align: center;
            border: 0.05rem solid #bababa;
            border-radius: 1.6rem;
            color: #999;
            margin-right: 1rem;
          }

          .video-group {
            flex: 1;

            .video-img {
              width: 4.25rem;
              height: 4.25rem;
              margin-right: 0.75rem;
              margin-bottom: 0.5rem;
            }

            a:last-child {
              .video-img {
                margin-right: 0;
              }
            }
          }

          .video-next {
            width: 0.58rem;
            height: 0.95rem;
            display: inline-block;
            margin-right: 0.2rem;
            background: url("../../assets/images/right_black.png") no-repeat scroll center/cover;
          }
        }
      }

      .panel-title {
        padding: 1.2rem 0 0.5rem 0.66rem;
        font-size: 1.5rem;
        color: #000b5d;
      }

      .product-info {
        padding: 0.66rem 1.2rem;
        margin-top: 1.33rem;
        background: #f2f4fb;
        border-radius: 0.33rem;

        .info {
          display: flex;
          align-items: center;
          font-size: 1.2rem;
          padding: 0.8rem 0;

          .info-title {
            color: #999;
            flex-shrink: 0;
            margin-right: 10px;
          }

          .info-name {
            flex: 1;
            font-size: 1.3rem;
            line-height: 1.5rem;
          }
        }
      }

      .product-type {
        padding: 1.66rem 0 0 0.66rem;

        .type {
          overflow: hidden;
          margin-bottom: 1rem;
          line-height: 1.6rem;

          .label {
            float: left;
            margin-right: 0.79rem;
          }

          .type-list {
            float: left;

            li {
              margin-bottom: 0.58rem;
              font-size: 1.3rem;
              line-height: 1.6rem;
            }

            .gray {
              margin: 0 0.625rem;
              color: #999;
            }
          }
        }
      }

      .characteristic {
        padding: 0.66rem;
        background: #f2f4fb;
        border-radius: 0.33rem;
        margin-bottom: 1.5rem;

        .characteristic-title {
          color: #999;
        }

        .text {
          padding-top: 0.66rem;
          font-size: 1.3rem;
          line-height: 2.3rem;
          word-break: break-all;
        }
      }

      .parameter {
        padding: 0.66rem 0 0.41rem 0.66rem;

        .parameter-item {
          display: inline-block;

          .label {
            margin-right: 0.41rem;
            color: #999;
          }

          .text {
            margin-right: 0.75rem;
          }
        }
      }

      .documents {
        padding: 1.5rem 0 0 0.66rem;

        .item {
          display: flex;
          align-items: center;
          margin-bottom: 1.33rem;

          .documents-img {
            width: 1.58rem;
            height: 1.66rem;
            display: inline-block;
            margin-right: 0.625rem;
            vertical-align: text-bottom;
          }

          .documents-info {
            display: inline-block;
            color: #666;
            flex: 1 1;
            min-width: 20%;

            .name {
              color: #597eff;
              line-height: 1.3rem;
            }
          }
        }
      }

      .base-list {
        padding: 1.06rem 0 0 0.66rem;

        li {
          display: inline-block;
          margin: 0 1.5rem 0.8rem 0;
          overflow: hidden;

          .label {
            color: #999;
            margin-right: 0.42rem;
            float: left;
          }

          .text {
            margin-right: 1rem;
            font-size: 1.2rem;
          }
        }
      }

      .industry-list {
        overflow: hidden;
        padding-top: 1.2rem;

        li {
          float: left;
          width: 23.5%;
          padding: 1rem 2%;
          text-align: center;
          position: relative;
          margin-right: 2%;
          box-sizing: border-box;
          background: #f2f4fb;
          border-radius: 0.5rem;
          margin-bottom: 1rem;

          &:nth-child(4n) {
            margin-right: 0;
          }

          p {
            font-size: 1.4rem;
            overflow: hidden;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          b {
            font-size: 1.2rem;
            line-height: 2.4rem;
            color: #3f89f7;
            overflow: hidden;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: normal;
          }

          span {
            font-size: 1.2rem;
            overflow: hidden;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: normal;
          }
        }

        .green {
          color: #67b246;
        }

        .red {
          color: #eb3323;
        }
      }

      .formula-table {
        padding-top: 1.16rem;

        .thead {
          padding: 0;
          background: #f2f4fb;
          border-radius: 0.5rem;
        }

        .tbody {
          .tr {
            border-bottom: 0.08rem dashed #cbcbcb;

            &:last-child {
              border-bottom: 0;
            }
          }
        }

        .tr {
          display: flex;
          text-align: center;
          padding: 5px 0;

          .th {
            flex: 1 1;
            padding: 0 0.5rem;
            min-height: 2rem;
            line-height: 2rem;
            color: #999;
            word-break: break-all;

            &:first-child,
            &:last-child {
              width: 30%;
            }
          }

          .td {
            flex: 1 1;
            padding: 0 0.5rem;
            line-height: 3.2rem;
            word-break: break-all;

            &:first-child,
            &:last-child {
              width: 20%;
            }
          }
        }
      }
    }

    .more-btn {
      display: block;
      width: 17.4rem;
      height: 3.45rem;
      margin: 2rem auto 0 auto;
      background-color: #fff;
      text-align: center;
      border-radius: 2rem;
      line-height: 3.45rem;
      margin-bottom: 3.3rem;
      color: #0c2870;
      font-size: 1.3rem;

      img {
        display: block;
        width: 100%;
      }
    }

    .tab-box {

      .interact {
        .interact-list {
          padding: 1.33rem 0;
          border-bottom: 0.08rem solid #efefef;

          .interact-item {
            margin-bottom: 1.5rem;

            &:last-child {
              margin-bottom: 0;
            }

            .user {
              overflow: hidden;
              padding-left: 0.66rem;

              .user-info {
                .cover {
                  float: left;
                  width: 2.66rem;
                  height: 2.66rem;
                  margin-right: 0.66rem;
                }

                .base {
                  float: left;
                }

                .name {
                  padding-top: 0.2rem;
                  font-weight: 600;
                }

                .time {
                  padding-top: 0.2rem;
                  color: #666;
                }
              }

              .reply-btn {
                float: right;

                .icon {
                  width: 0.83rem;
                  height: 0.71rem;
                  display: inline-block;
                  margin: 1.51rem 0.41rem 0 0;
                  background: url("../../assets/images/message.png") no-repeat scroll top/cover;
                }

                .reply-text {
                  color: #164aff;
                }
              }
            }

            .interact-warrper {
              overflow: hidden;
              padding: 1.04rem 0 0 0.66rem;

              .interact-text {
                color: #666;
                line-height: 1.6rem;
                word-break: break-all;
              }

              .show-btn {
                float: right;
                padding: 0 0.8rem 0 1.6rem;
                line-height: 1.6rem;
                font-weight: bold;
              }
            }

            .other-reply {
              padding: 1.25rem 0;
              margin-top: 1.66rem;
              background: #f6f7fa;

              .get-more {
                padding-top: 0;
              }
            }
          }
        }

        .get-more {
          padding-top: 1.75rem;
          text-align: center;
          font-size: 1.3rem;
          line-height: 1.3rem;

          .more-icon {
            width: 0.58rem;
            height: 1.16rem;
            display: inline-block;
            margin-left: 0.5rem;
            background: url("../../assets/images/more_icon.png") no-repeat scroll top/cover;
            vertical-align: text-bottom;
          }
        }
      }

      .recommed-list {
        overflow: hidden;

        .recommed-warrper {
          width: 50%;
          float: left;

          .recommend-item {
            padding: 1.33rem 1rem 1.16rem;
            height: 9.2rem;

            &:nth-of-type(2n) {
              background: #f6f7fa;
            }

            .recommend-title-warrper {
              height: 4.16rem;
              margin-bottom: 1rem;
            }

            .recommend-title {
              padding: 0 0 0 0.83rem;
              word-break: break-all;
              font-size: 1.7rem;
              font-weight: bold;
              line-height: 2.2rem;
              border-left: 0.16rem solid #5178ff;
            }

            .recommend-text {
              padding: 0 0 0.5rem 0.83rem;
              color: #999;
            }
          }
        }
      }
    }
  }

  .shop_logo {
    border-radius: 5px;
  }

  .product-desc {
    font-size: 1.2rem;
    color: #999;
    padding: 2rem 1rem 0;
    line-height: 2rem;
  }

  .icon-join {
    width: 2.8rem;
    height: 2.8rem;
    vertical-align: text-bottom;
  }

  .product-edit-btns {
    display: flex;
    align-items: center;
    padding: 0 1rem 2rem 1rem;

    p {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 1.4rem;
      margin-left: 2rem;

      &:first-child {
        margin-left: 0;
      }

      img {
        display: block;
        width: 1.8rem;
        margin-right: 0.5rem;
      }
    }
  }

  .product-video {
    width: 100%;
    margin: 1.33rem 0;
    border-radius: 12px;
    overflow: hidden;

    video {
      height: 20rem;
    }

    img {
      display: block;
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home/product_details.vue